import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

export function getStockDisponible(producto) {
  const n = Number(producto?.stockDisponible ?? producto?.stock);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.floor(n));
}

export function stockLabel(qty) {
  const n = Math.max(0, Math.floor(Number(qty) || 0));
  if (n === 0) return 'Sin stock';
  if (n === 1) return '1 disponible';
  return `${n} disponibles`;
}

export function stockColor(qty) {
  const n = Math.max(0, Math.floor(Number(qty) || 0));
  if (n === 0) return 'default';
  if (n <= 3) return 'warning';
  return 'success';
}

/** Chip compacto para grid y detalle */
export default function CatalogStockLabel({ producto, variant = 'chip', sx }) {
  const qty = getStockDisponible(producto);
  const label = stockLabel(qty);

  if (variant === 'text') {
    return (
      <Typography
        variant="caption"
        sx={{
          fontWeight: 600,
          color: qty === 0 ? 'text.disabled' : qty <= 3 ? 'warning.main' : 'success.main',
          ...sx,
        }}
      >
        {label}
      </Typography>
    );
  }

  return (
    <Chip
      label={label}
      size="small"
      color={stockColor(qty)}
      variant={qty === 0 ? 'outlined' : 'filled'}
      sx={{ borderRadius: 1, fontWeight: 600, ...sx }}
    />
  );
}
